import { useCallback, useEffect, useState } from "react";
import { countPending } from "@/lib/outbox";
import { syncOutbox } from "@/lib/sync";
import { toast } from "sonner";

export function useOffline() {
  const [online, setOnline] = useState(typeof navigator !== "undefined" ? navigator.onLine : true);
  const [pending, setPending] = useState(0);
  const [syncing, setSyncing] = useState(false);

  const refresh = useCallback(async () => {
    try { setPending(await countPending()); } catch (_) {}
  }, []);

  const doSync = useCallback(async () => {
    if (!navigator.onLine) return;
    setSyncing(true);
    try {
      const res = await syncOutbox(refresh);
      if (res.skipped > 0) toast.info(`${res.skipped} débrief${res.skipped > 1 ? "s" : ""} hors ligne ignoré${res.skipped > 1 ? "s" : ""} : aucune parole compréhensible détectée`);
      if (res.synced > 0) toast.success(`✅ ${res.synced} fiche${res.synced > 1 ? "s" : ""} synchronisée${res.synced > 1 ? "s" : ""}`);
    } finally {
      setSyncing(false);
      await refresh();
    }
  }, [refresh]);

  useEffect(() => {
    refresh();
    const goOnline = () => { setOnline(true); doSync(); };
    const goOffline = () => setOnline(false);
    const onChange = () => refresh();
    window.addEventListener("online", goOnline);
    window.addEventListener("offline", goOffline);
    window.addEventListener("klt-outbox-changed", onChange);
    const iv = setInterval(refresh, 6000);
    if (navigator.onLine) doSync();
    return () => {
      window.removeEventListener("online", goOnline);
      window.removeEventListener("offline", goOffline);
      window.removeEventListener("klt-outbox-changed", onChange);
      clearInterval(iv);
    };
  }, [refresh, doSync]);

  return { online, pending, syncing, doSync, refresh };
}
